import React from 'react';
import { motion } from 'framer-motion';
import { Clock, HelpCircle, AlertTriangle, Search } from 'lucide-react';
const painPoints = [{
  icon: <Clock className="w-6 h-6 text-accent-orange" data-id="element-111" />,
  title: 'Domingos perdidos',
  description: 'adaptando libros de química general a ejemplos de taller que no existen.'
}, {
  icon: <HelpCircle className="w-6 h-6 text-accent-orange" data-id="element-112" />,
  title: 'Tus alumnos preguntan',
  description: '"¿esto para qué me sirve?" y te falta el ejemplo industrial exacto.'
}, {
  icon: <AlertTriangle className="w-6 h-6 text-accent-orange" data-id="element-113" />,
  title: 'Estrés en la muestra anual',
  description: 'por no tener proyectos integradores que realmente funcionen.'
}, {
  icon: <Search className="w-6 h-6 text-accent-orange" data-id="element-114" />,
  title: 'Buscando guías',
  description: 'de laboratorio seguras y aplicadas a los materiales de cada tecnicatura.'
}];
export function PainPoints() {
  return <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-115">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-8 md:mb-12" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-bold" data-id="element-117">¿Te suena familiar?</h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-118">
        {painPoints.map((point, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-primary-card rounded-xl p-5 border-l-4 border-l-accent-orange border-y border-r border-primary-card hover:border-r-accent-orange/30 hover:border-y-accent-orange/30 transition-colors flex gap-4 items-start" data-id="element-119">
            <div className="shrink-0 mt-1 bg-primary p-2 rounded-lg" data-id="element-120">
              {point.icon}
            </div>
            <div data-id="element-121">
              <h3 className="text-xl font-bold mb-2" data-id="element-122">{point.title}</h3>
              <p className="text-text-muted leading-relaxed" data-id="element-123">
                {point.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}